import {ChangeDetectionStrategy, Component, HostBinding, Inject, Optional} from "@angular/core";
import {IntCalendarCellComponent} from "../cell";
import {DateControllerStateDirective} from "../../directives";

@Component({
  selector: 'int-month-cell',
  template: `
    <span class="c-inner">
      <button
        [disabled]="isDisabled"
        (click)="onSelectHandler()"
        class="c-action">
     <ng-content></ng-content>
    </button>
      <span class="current-day-mark"></span>
    </span>
  `,
  styleUrls: [`../cell/calendar-cell.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntMonthCellComponent extends IntCalendarCellComponent {

  constructor(
    @Optional()
    @Inject(DateControllerStateDirective) protected readonly controller: DateControllerStateDirective
  ) {
    super(controller);
  }

  get _selfDay() {
    return false;
  }
  @HostBinding('class.is-selected')
  get _isSelected() {
    return this.selectedDates.some((date) => {
      const {year, month} = date;
      const {year: _year, month: _month} = this.cellData;
      return ((_month - 1) === month) && (_year === year);
    });
  }

  @HostBinding('class.is-start-range')
  get _isStartRange() {
    const {year: _year, month: _month, day: _day} = this.cellData;
    const cellTimestamp = new Date(_year, _month - 1).getTime();
    const [min] = this.getSelectedTimestamps();
    return cellTimestamp === min;
  }

  @HostBinding('class.is-end-range')
  get _isEndRange() {
    const {year: _year, month: _month, day: _day} = this.cellData;
    const cellTimestamp = new Date(_year, _month - 1).getTime();
    const [_, max] = this.getSelectedTimestamps();
    return cellTimestamp === max;
  }

  @HostBinding('class.is-current-date')
  get _isCurrentMonth() {
    const {year: _year, month: _month} = this.cellData;
    const cY = this.currentDate.getFullYear();
    const cM = this.currentDate.getMonth();
    return (_year === cY) && (_month - 1 === cM);
  }

  getSelectedTimestamps() {
    const d1 = new Date(this.selectedDates[0]?.year, this.selectedDates[0]?.month).getTime();
    const d2 = this.selectedDates[1]
      ? new Date(this.selectedDates[1]?.year, this.selectedDates[1]?.month).getTime()
      : new Date(
        <number>this.controller.hoveredCellState?.year,
        <number>this.controller.hoveredCellState?.month - 1
      ).getTime()
    const sortDates = [d1, d2].sort();
    return sortDates;
  }
}
